var map = {
	"./bgm_loop_1.wav": 774,
	"./bgm_loop_10.wav": 6426,
	"./bgm_loop_11.wav": 67411,
	"./bgm_loop_12.wav": 47148,
	"./bgm_loop_2.wav": 35537,
	"./bgm_loop_3.wav": 43688,
	"./bgm_loop_4.wav": 83203,
	"./bgm_loop_5.wav": 69194,
	"./bgm_loop_6.wav": 80789,
	"./bgm_loop_7.wav": 28764,
	"./bgm_loop_8.wav": 36695,
	"./bgm_loop_9.wav": 98286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77165;